<template>
  <section class="my-30">
    <Container>
      <SectionHeader>Location</SectionHeader>
      <div class="rounded-lg overflow-hidden">
        <div class="h-[400px] lg:h-[540px]">
          <HMTMapFrame :disabledButton="true" />
        </div>
        <div class="bg-[#F3F5FB] px-6 lg:px-12 py-8 flex flex-col md:flex-row gap-6 justify-between items-center">
          <div class="space-y-1 text-center md:text-left text-secondary-color text-xl lg:text-2xl">
            <div>{{ addressPart1 }}</div>
            <div>{{ addressPart2 }}</div>
          </div>
          <button 
            class="text-white px-6 py-2 rounded-lg cursor-pointer"
            :class="{ 
              'bg-primary-color': !getPrimaryColor,
              [`bg-[${getPrimaryColor}]`]: getPrimaryColor
            }"
            @click="showMap"
          >
            View Map
          </button>
        </div>
      </div>
    </Container>
  </section>
</template>

<script>
  import HMTMapFrame from '@/shared/components/MapFrame';
  import Container from '../../components/Container';
  import SectionHeader from '../../components/SectionHeader';
  import addressMixin from '@/shared/mixins/address';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'Map',
    mixins: [
      addressMixin
    ],
    components: {
      HMTMapFrame,
      Container,
      SectionHeader
    },
    computed: {
      ...mapGetters('tour', ['getPrimaryColor']),
    },
    methods: {
      ...mapActions('ui', ['runViewMap']),
      showMap () {
        this.runViewMap();
      }
    }
  };
</script>
